// @ts-nocheck
import formatDate from "includes/formatDate";
import genRequest from "includes/request";

class ReactionTypeObject {
	#reactionTypeId = null;
	#name = "";
	#description = "";
	#reactionDesignId = 1;
	#companyId = null;
	#lastChanged = null;
	#lastChangeAuthorId = null;

	#linkedReactions = [];

	constructor(props) {
		this.#initValues(props);
	}

	#initValues = (obj) => {
		let date = formatDate();
		this.#reactionTypeId = (obj?.id || obj?.reactionTypeId ? (obj.id || obj.reactionTypeId) : null);
		this.#name = (obj?.name ? obj.name : "");
		this.#description = (obj?.description ? obj.description : "");
		this.#reactionDesignId = (obj?.reactionDesignId ? obj.reactionDesignId : 1);
		this.#companyId = (obj?.companyId ? obj.companyId : null);
		this.#lastChanged = (obj?.lastChanged ? obj.lastChanged : date);
		this.#lastChangeAuthorId = (obj?.lastChangeAuthorId ? obj.lastChangeAuthorId : null);
	};

	send = () => {
		let that = this;
		let prom = new Promise((resolve, reject) => {
			that.sendType()
				.then(() => {
					return (that.unlinkReactions());
				}, reject)
				.then(() => {
					return (that.linkReactions());
				}, reject)
				.then(resolve, reject);
		});
		return (prom);
	};

	sendType = () => {
		let req = genRequest(
			"reaction-types" + (this.#reactionTypeId ? `/${this.#reactionTypeId}` : ""),
			this.values(),
			this.#reactionTypeId ? "put" : "post"
		).then((resp) => {
			if (!this.#reactionTypeId)
				this.#initValues(resp);
		});
		return (req);
	};

	unlinkReactions = () => (
		!this.#reactionTypeId ?
			Promise.resolve(true)
			:
			genRequest("reactions/type/" + this.#reactionTypeId + "/links", null, "delete")
	);

	linkReactions = () => {
		if (!this.#linkedReactions?.length)
			return (Promise.resolve(true));
		let prom = genRequest(
			"reactions/type/" + this.#reactionTypeId + "/links",
			{ reactionIds: this.#linkedReactions.map((a) => a.id) },
			"post"
		);
		return (prom);
	};

	fetchLinkedReactions = () => {
		let that = this;
		let req = genRequest("reactions/typed/" + this.#reactionTypeId).then((resp) => {
			that.#linkedReactions = resp;
		});
		return (req);
	};

	linkedReactions = (setLinked) => {
		if (typeof setLinked !== "undefined")
			this.#linkedReactions = setLinked;
		return (this.#linkedReactions);
	};

	delete = () => {
		let prom = new Promise((resolve, reject) => {
			if (!this.#reactionTypeId)
				resolve (true);
			this.unlinkReactions()
				.then(() => {
					let req = genRequest(
						"reaction-types/" + this.#reactionTypeId,
						null,
						"delete"
					);
					return (req);
				}, reject)
				.then(resolve, reject);
		});
		return (prom);
	};

	reactionTypeId = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#reactionTypeId = setValue;
		return (this.#reactionTypeId);
	};

	name = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#name = setValue;
		return (this.#name);
	};

	description = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#description = setValue;
		return (this.#description);
	};

	reactionDesignId = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#reactionDesignId = setValue;
		return (this.#reactionDesignId);
	};

	companyId = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#companyId = setValue;
		return (this.#companyId);
	};

	lastChanged = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#lastChanged = setValue;
		return (this.#lastChanged);
	};

	lastChangeAuthorId = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#lastChangeAuthorId = setValue;
		return (this.#lastChangeAuthorId);
	};

	values = () => {
		let ret = {
			reactionTypeId: this.#reactionTypeId,
			name: this.#name,
			description: this.#description,
			reactionDesignId: this.#reactionDesignId,
			companyId: this.#companyId,
			lastChanged: this.#lastChanged,
			lastChangeAuthorId: this.#lastChangeAuthorId,
		};

		if (!ret.reactionTypeId)
			delete ret.reactionTypeId;
		return (ret);
	};
}

export default ReactionTypeObject;
